module.exports = __webpack_public_path__ + "static/media/101.bc9ed081.png";